import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import Edit from '@material-ui/icons/Edit'
import Button from 'components/CustomButtons/Button.jsx'
import Card from 'components/Card/Card.jsx'
import CardBody from 'components/Card/CardBody.jsx'
import GridContainer from 'components/Grid/GridContainer.jsx'
import GridItem from 'components/Grid/GridItem.jsx'
import translation from '../../translation/translate'
import { toLocaleDateString, getUserToken } from 'services/utils'
import api from 'api'
import { withStyles } from '@material-ui/core'
import style_custom from 'assets/css/style_custom.jsx';

const client = process.env.REACT_APP_CLIENT
const styles = require(`../../assets/css/style.jsx`).default;

class OperationCardItem extends React.Component {
  state = {
    is_signed: null,
    participation:true,
    logoSwitch:'',
    userCurrent:'',
    ibanTrue:true
  };


  componentWillMount() {
    const operation = this.props.operation;
    let comparison = null;
    api.user.get_curr()
        .then(resp => {
          this.setState({ userCurrent: resp.data })
        })
    if (!operation.needSignature) {
      this.setState({is_signed: true})
    } else {
      api.operations.is_signed(operation.id, getUserToken().id)
          .then(resp => {
            this.setState({is_signed: null !== resp.data.validationDate})

          })
          .catch(error => {this.setState({is_signed: false})})
    }
    _.map(this.props.operation.operationCustomers, function(itemOp) {
      comparison = Object.assign(itemOp)
    });

    if(comparison && comparison.counter === comparison.partMax){
      this.setState({participation: false})
    }
  }

  render () {
    const { classes, operation, signConfirmAlert } = this.props;
    const { is_signed, participation } = this.state;
    const NameBrands = operation.brand && operation.brand.name;
    let req = require(`../../assets/img/logos-wrapper.png`);
    if(NameBrands === "VICHY" || NameBrands === "ROGER&GALLET" || NameBrands === "LA-ROCHE-POSAY" || NameBrands === "SkinCeuticals" || NameBrands === "Sanoflore" || NameBrands === "CERAVE" || NameBrands === "DECLEOR" ){
    }
    let button;
    if (new Date(operation.closingDate) >= new Date() && this.state.userCurrent.cachedIban && this.state.userCurrent.cachedBic) {
      button = <Button style={styles.btnPart} size='sm' component={Link} to={{pathname:`/nouvelle-demande/${operation.id}`, state:operation['@type']}}>{translation[client].home_new}</Button>
    }
    else if (new Date(operation.closingDate) < new Date()) {
      button = '';
    }
    else {
      button = <Button style={styles.btnPart} component={Link} to={`/mon-profil`}>{translation[client].home_new}</Button>;
      /* button =  <Button style={styles.btnOPBlack} component={Link} to={{
         pathname: '/mon-profil',
         state: {
           ibanTrue:false
         }
       }}>{translation[client].home_new}</Button>;*/
    }
    return (
        <Card className={classes.cardHover} style={styles.opWrapper}>
          <div>
            {operation.operationCustomers.length > 0 && operation.operationCustomers[0].partMax <= operation.operationCustomers[0].counter &&
            <div className={classes.cornerRibbon} ><p style={{color:'white', textAlign:'center', fontSize:'25px', paddingTop:'5%'}}>Vous avez<br/> déjà participé</p></div>
            }
            <CardBody className={classes.myCardBody}>
              <GridContainer>
                <GridItem xs={12} sm={4}>
                  {true === participation && operation.image && operation.image.contentUrl &&
                  <img className={classes.img_valid} src={`${process.env.REACT_APP_BACKEND_URL}/media/${operation.image.contentUrl}`} onError={e => {e.target.src = `/emptyImg.jpg`}} alt="..."/>
                  }
                </GridItem>
                <GridItem xs={12} sm={8}>
                  <h4 style={styles.titleOP}>{operation.title}</h4>
                  {new Date(operation.closingDate) >= new Date() &&
                  <p style={styles.statusOperation}>Opération en cours</p>
                  }
                  {new Date(operation.closingDate) < new Date() &&
                  <p style={styles.statusOperationFinish}>Opération terminée</p>
                  }
                  <p className={classes.cardCategory} style={styles.descrOP}>{operation.description}</p>
                  <div className={classes.stats}>
                    <p style={styles.descrOP}>
                      Opération du <span style={styles.spanColor}> {toLocaleDateString(operation.startDate)} </span> au <span style={styles.spanColor}> {toLocaleDateString(operation.endDate)}</span>
                      <br/>
                      Déclaration possible jusqu'au <span style={styles.spanColor}> {toLocaleDateString(operation.closingDate)}</span>
                    </p>
                  </div>

                  <div style={styles.btnBarOP}>
                    {button}
                    {false === is_signed &&
                    <Button style={styles.btnOPTransp} onClick={signConfirmAlert}><Edit className={classes.underChartIcons}/>SIGNER LE CONTRAT</Button>
                    }
                    {null === this.props.operation.contract.contentUrl ?(
                        <Button type={'button'} rel='noreferrer noopener' target='_blank' style={styles.btnOPTransp}>Téléchargez et imprimez votre mandat</Button>
                    ):(
                        <Button style={styles.btnOPTransp} href={`${process.env.REACT_APP_BACKEND_URL}/media/${operation.contract.contentUrl}`} type={'button'} rel='noreferrer noopener' target='_blank'>Téléchargez et imprimez votre mandat</Button>
                    )}
                    {operation.brand && operation.brand.name &&
                    <img style={styles.imgLogoBrand} src={req}/>
                    }
                  </div>
                </GridItem>
              </GridContainer>
            </CardBody>
          </div>
        </Card>
    )
  }
}

OperationCardItem.propTypes = {
  classes: PropTypes.object.isRequired,
  operation: PropTypes.object.isRequired,
  signConfirmAlert: PropTypes.func.isRequired
};

export default withStyles(style_custom)(OperationCardItem)



// WEBPACK FOOTER //
// ./src/views/Components/OperationCardItem.jsx